import {pageInfo,pageInfoDetails} from './../api';
import { Message } from 'element-ui';
  const distribute = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    detailsInfo:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    DISTRIBUTE_INFO_DETAILS(state,data){
      state.detailsInfo = data.obj || [];
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

    //查询事件(延迟原因总汇总)
    async distributeInfoDetails({commit}, obj){
      let resp = await pageInfoDetails(obj);
      commit('DISTRIBUTE_INFO_DETAILS', resp);
    }
  },

}
export default distribute



// WEBPACK FOOTER //
// ./src/page/report/distribute/store/distribute.store.js